import React, { Component } from 'react';
import { TableDefault } from '../../../../components';

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: '',
      page: 1,
      pageSize: 100,
      totalItems: 0,
      orderBy: 'Descricao',
      order: '',
      urlDelete: '/Modelo/Delete/',
      urlEdit: '/admin/modelos-mensagem/editar/',
      urlLoad: '/Modelo/GetListagem/',
    };
  }

  render() {
    const {
      page,
      pageSize,
      totalItems,
      search,
      order,
      orderBy,
      urlDelete,
      urlEdit,
      urlLoad,
    } = this.state;

    const { type } = this.props;
    return (
      <div>
        <TableDefault
          search={search}
          type={type}
          order={order}
          orderBy={orderBy}
          page={page}
          pageSize={pageSize}
          totalItems={totalItems}
          urlDelete={urlDelete}
          urlEdit={urlEdit}
          urlLoad={urlLoad}
        />
      </div>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/screens/admin/MessageModels/List/List.jsx